import { Chip, Stack, Typography } from "@mui/material";
import { useTenantTranslation } from "hooks/formatters";
import { HeatOverrideChargeDelta } from "src/store/api/generatedApi";
import { useDeltaWeightFormat } from "./useDeltaWeightFormat";

const MaterialDeltaChips = ({
  chargeDelta,
}: {
  chargeDelta: HeatOverrideChargeDelta;
}) => {
  const { formatSignedWeight } = useDeltaWeightFormat();
  return (
    <Stack direction="row" sx={{ gap: 0.5, flexWrap: "wrap" }}>
      {chargeDelta.material_deltas.map((materialDelta) => (
        <Chip
          key={materialDelta.material_name}
          size="small"
          variant="outlined"
          color={materialDelta.mass_delta_per_heat < 0 ? "warning" : "success"}
          label={`${formatSignedWeight(materialDelta.mass_delta_per_heat)} ${materialDelta.material_name}`}
        />
      ))}
    </Stack>
  );
};

export const ChargeDeltaList = ({
  chargeDeltas,
}: {
  chargeDeltas: HeatOverrideChargeDelta[];
}) => {
  const { t } = useTenantTranslation();
  return (
    <Stack sx={{ gap: 1 }}>
      <Typography variant="body2" sx={{ color: "text.secondary" }}>
        {t("deltaMaterialChanges")}
      </Typography>
      {chargeDeltas.map((chargeDelta) => (
        <Stack
          key={chargeDelta.basket_number}
          direction="row"
          sx={{ gap: 1.5, alignItems: "center" }}
        >
          <Typography variant="body2" sx={{ minWidth: 72 }}>
            {t("deltaChargeNumber", { charge: chargeDelta.basket_number })}
          </Typography>
          <MaterialDeltaChips chargeDelta={chargeDelta} />
        </Stack>
      ))}
    </Stack>
  );
};
